import { FC } from 'react';
import { Input } from 'antd';
import { SearchSuffix } from '@dynamika-shared/ui/Input/SearchSuffix';

interface SubjectSearchBarProps {
  totalElements: number;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onClearSearch: () => void;
}

export const SubjectSearchBar: FC<SubjectSearchBarProps> = ({
  totalElements,
  searchValue,
  onSearchChange,
  onClearSearch,
}) => {
  return (
    <div className='flex justify-between pb-3 pt-[13px]'>
      <h2 className='flex items-center text-[24px] font-semibold'>
        Subject List{' '}
        {!!totalElements && (
          <>
            <span className='width-[6px] height-[6px] mx-0.5 text-pastelBlue'>
              •
            </span>
            <span className='text-1824 font-medium'>{totalElements} </span>
            <span className='ml-0.5 text-1624 font-medium'>
              {totalElements === 1 ? 'Subject' : 'Subjects'}
            </span>
          </>
        )}
      </h2>

      <div className='flex items-center'>
        <Input
          placeholder='Search Subject ID...'
          className='min-w-[400px] max-w-lg rounded-[32px] px-2 py-[10px] text-1424 text-spanishGray'
          style={{ boxShadow: 'none' }}
          suffix={
            <SearchSuffix action={onClearSearch} disabled={!searchValue} />
          }
          value={searchValue}
          onChange={({ target: { value } }) => {
            const upperCaseValue = value.toUpperCase();
            onSearchChange(upperCaseValue);
          }}
        />
      </div>
    </div>
  );
};
